import { itemsApi } from "#/api/itemsApi";
import ActionButton from "#/components/buttons/ActionButton";

import { showSuccessNotification } from "#/components/notifications";
import Popover from "#/components/overlays/Popover";
import type { Item, SendMessagePayload } from "#/types/items";
import { Avatar, Button, Textarea, TextInput, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconMail, IconSend2 } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface Props {
  item: Item;
}
const NotifyPopover = ({ item }: Props) => {
  const { t } = useTranslation();
  const [sending, setSending] = useState<boolean>(false);

  const [opened, { open, close, toggle }] = useDisclosure(false);

  const form = useForm<SendMessagePayload>({
    initialValues: {
      subject: "",
      message: "",
    },
    validate: {
      subject: (value) => (value ? null : "Subject is required"),
      message: (value) => (value ? null : "Message is required"),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setSending(true);

    try {
      const res = await itemsApi.sendMessage(item.id, values);
      close();
      setSending(false);
      showSuccessNotification({
        message: res.message ?? "Message sent successfully",
      });
      form.reset();
    } catch (error) {
      console.error("🚀 ~ handleSubmit ~ error:", error);
      setSending(false);
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <Popover
        width={300}
        opened={opened}
        onChange={toggle}
        anchor={
          <ActionButton icon={IconMail} variant="outline" onClick={open} />
        }
      >
        <form
          className="w-full flex flex-col space-y-4 p-2 h-full"
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <div className="w-full grid grid-cols-[auto_1fr] gap-2 items-center">
            <Avatar name={item.notify_email} size={"md"} color="initials" />
            <Title order={5}>{item.notify_email || "--"}</Title>
          </div>
          <TextInput
            withAsterisk
            label={t("tickets.notify.subject")}
            placeholder={t("tickets.notify.subjectPlaceholder")}
            {...form.getInputProps("subject")}
          />

          {/* <div className="w-full flex h-36"></div> */}
          <Textarea
            withAsterisk
            label={t("tickets.notify.message")}
            placeholder={t("tickets.notify.messagePlaceholder")}
            classNames={{
              input: "h-36",
            }}
            {...form.getInputProps("message")}
          />

          <Button
            loading={sending}
            type="submit"
            leftSection={<IconSend2 size={18} />}
            color="green.5"
          >
            {t("tickets.notify.sendMessage")}
          </Button>
        </form>
      </Popover>
    </div>
  );
};

export default NotifyPopover;
